import './styles.scss';

const NoWebGLPlaceholder = () => {
  return (
    <div className="no-webgl-placeholder">
      <p>
        Browser graphics acceleration not enabled.
        <br />
        To view the chart, enable this option in your browser settings.
      </p>
    </div>
  );
};

export default NoWebGLPlaceholder;
